import { render } from "./Tal_helpBoardPop.vue?vue&type=template&id=8809cc8e"
const script = {}

import "./Tal_helpBoardPop.vue?vue&type=style&index=0&id=8809cc8e&lang=css"

import exportComponent from "C:\\Users\\SAEUM\\Desktop\\teampl-project\\github\\unibuzzy\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__